import { styled, Stack } from '@withjoy/joykit';

export const EnhancedStack = styled(Stack)`
  text-align: center;
`;

export const ButtonStack = styled(Stack)`
  justify-content: center;
`;
